import {Component, Input} from '@angular/core';
import {User, UserRoles} from '../../entities/user/user.entity';
import { NgStyle } from '@angular/common';
import {AppImageComponent} from '../image/image';

@Component({
  selector: 'app-user-image',
  imports: [
    NgStyle,
    AppImageComponent
  ],
  templateUrl: './user-image.component.html',
  standalone: true,
  styleUrl: './user-image.component.scss'
})
export class UserImageComponent {
  @Input() user: User|null = null;
  @Input() size: number = 32;
  protected readonly UserRoles = UserRoles;
}
